import EventEmitter from "./utils/EventEmitter";

export default class Headers extends EventEmitter {
    constructor(element) {
        super();

        this.el = element

        this.authorsMedallionList = this.el.querySelector('.authors-header-list-container')

        this.init()
    }

    init() {

        if (this.authorsMedallionList) {
            this.getAuthorsMedallionList()
        }
    }
    getAuthorsMedallionList() {
        const authors = document.querySelectorAll('.authors-list-hidden-data .author')

        let data = []

        // get authors data from data attributes
        authors.forEach(author => {
            if (author.classList.contains('author-int')) {

                const authorData = {
                    label: author.dataset.label,
                    image: author.querySelector('img') ? author.querySelector('img').getAttribute('src') : null,
                    url: author.dataset.url
                }
                data.push(authorData)
            }
            if (author.classList.contains('author-ext')) {
                const authorData = {
                    label: author.dataset.label,
                }
                data.push(authorData)
            }
        })

        this.populateAuthorsMedallionList(data)
    }

    populateAuthorsMedallionList(data) {
        if (!data.find(author => author.image)) {
            this.authorsMedallionList.querySelector('.medallion-list').remove()
        }

        data.forEach(author => {

            if (author.image) {
                const authorMedallion = document.createElement('div')
                authorMedallion.classList.add('u-medallion')

                const authorLink = document.createElement('a')
                authorLink.setAttribute('href', author.url)

                const authorImage = document.createElement('img')
                authorImage.setAttribute('src', author.image)
                authorMedallion.appendChild(authorImage)

                // Mettre l'image dans le lien
                authorLink.appendChild(authorMedallion)

                this.authorsMedallionList.querySelector('.medallion-list').appendChild(authorLink)
            }

            if (author.label) {

                if (author.url) {
                    const authorLabel = document.createElement('div')
                    authorLabel.classList.add('u-mr15', 't-fs13')
                    const link = document.createElement('a')
                    link.setAttribute('href', author.url)
                    link.innerText = author.label
                    authorLabel.appendChild(link)
                    this.authorsMedallionList.querySelector('.label-list-authors').appendChild(authorLabel)
                } else {
                    const authorLabel = document.createElement('div')
                    authorLabel.classList.add('u-mr15', 't-fs13')
                    authorLabel.innerText = author.label
                    this.authorsMedallionList.querySelector('.label-list-authors').appendChild(authorLabel)
                }

            }

        })

        if (!data.find(author => author.image) && document.querySelector('.authors-bottom')) {
            document.querySelector('.authors-bottom').style.display = 'none'
        }

    }

}
